// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Primary colors */
  --color-white: #ffffff;
  --color-blue: rgba(80, 185, 255, 0.75);
  --color-darker-blue: rgba(80, 185, 255, 1);
  --color-red: rgba(255, 128, 80, 0.95);
  --color-yellow: #fffb8d;
  user-select: none;
}

body {
  display: flex;
  justify-content: center;
}

#pageTitle {
  text-align: center;
}

#mainContent {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  min-width: 560px;
}

div.player1-container,
div.player2-container {
  position: relative;
  flex-shrink: 0;
  padding: 5px 5px;
  text-align: center;
}

td {
  width: 52px;
  height: 52px;
  background: var(--color-blue);
  font-size: 2.5rem;
  text-align: center;
}

td:hover {
  background: var(--color-darker-blue);
}

td.hit {
  background: var(--color-red);
}

td.hit,
td.miss {
  pointer-events: none; /* Not clickable */
}

img.fire {
  display: block; /* Needed, to avoid resizing <td> */
  height: 90%;
  width: 80%;
  justify-self: center;
}

img.ship {
  position: absolute;
  pointer-events: none; /* Note: might need to remove this to enable drag-n-drop */
}

button.dialog {
  padding: 8px 16px;
}

dialog#startNewGameModal {
  text-align: center;
}
summary,
details {
  outline: none;
  user-select: none;
  padding-bottom: 8px;
}
summary:hover {
  text-shadow: #6e6e6e 2px 0 16px;
}
.form-group {
  padding: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;EACtC,0CAA0C;EAC1C,qCAAqC;EACrC,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,oBAAoB,EAAE,kBAAkB;AAC1C;;AAEA;EACE,cAAc,EAAE,mCAAmC;EACnD,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB,EAAE,0DAA0D;AAClF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;AACd","sourcesContent":[":root {\r\n  /* Primary colors */\r\n  --color-white: #ffffff;\r\n  --color-blue: rgba(80, 185, 255, 0.75);\r\n  --color-darker-blue: rgba(80, 185, 255, 1);\r\n  --color-red: rgba(255, 128, 80, 0.95);\r\n  --color-yellow: #fffb8d;\r\n  user-select: none;\r\n}\r\n\r\nbody {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n#pageTitle {\r\n  text-align: center;\r\n}\r\n\r\n#mainContent {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-evenly;\r\n  min-width: 560px;\r\n}\r\n\r\ndiv.player1-container,\r\ndiv.player2-container {\r\n  position: relative;\r\n  flex-shrink: 0;\r\n  padding: 5px 5px;\r\n  text-align: center;\r\n}\r\n\r\ntd {\r\n  width: 52px;\r\n  height: 52px;\r\n  background: var(--color-blue);\r\n  font-size: 2.5rem;\r\n  text-align: center;\r\n}\r\n\r\ntd:hover {\r\n  background: var(--color-darker-blue);\r\n}\r\n\r\ntd.hit {\r\n  background: var(--color-red);\r\n}\r\n\r\ntd.hit,\r\ntd.miss {\r\n  pointer-events: none; /* Not clickable */\r\n}\r\n\r\nimg.fire {\r\n  display: block; /* Needed, to avoid resizing <td> */\r\n  height: 90%;\r\n  width: 80%;\r\n  justify-self: center;\r\n}\r\n\r\nimg.ship {\r\n  position: absolute;\r\n  pointer-events: none; /* Note: might need to remove this to enable drag-n-drop */\r\n}\r\n\r\nbutton.dialog {\r\n  padding: 8px 16px;\r\n}\r\n\r\ndialog#startNewGameModal {\r\n  text-align: center;\r\n}\r\nsummary,\r\ndetails {\r\n  outline: none;\r\n  user-select: none;\r\n  padding-bottom: 8px;\r\n}\r\nsummary:hover {\r\n  text-shadow: #6e6e6e 2px 0 16px;\r\n}\r\n.form-group {\r\n  padding: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
